<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="page_title">注销列表(医)</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <span>医生名称</span>
          <el-input
            v-model="doctor_name"
            style="width: 130px; margin: 0 10px"
            clearable
            @change="search"
          >
          </el-input>
          <span>手机号</span>
          <el-input
            v-model="phone"
            style="width: 130px; margin: 0 10px"
            clearable
            @change="search"
          ></el-input>
          <span>提交时间</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 225px; margin: 0 10px"
            @change="search"
          >
          </el-date-picker>
          <span>身份证号</span>
          <el-input
            v-model="id_card"
            style="width: 130px; margin: 0 10px"
            clearable
            @change="search"
          ></el-input>
          <span style="margin-right: 10px">标记状态</span>
          <el-select
            v-model="remark_status"
            clearable
            placeholder="请选择"
            style="margin-right: 10px"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span style="margin-right: 10px">标记时间</span>
          <el-date-picker
            v-model="remark_time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <el-button
            type="info"
            style="background-color: #eceff2; color: #747981"
            @click="search"
            >查询</el-button
          >
          <span>
            <span style="margin: 0 10px 0 15px">注销结果</span>
            <el-radio-group v-model="status" @change="search">
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">待审核</el-radio>
              <el-radio :label="2">已注销</el-radio>
              <el-radio :label="3">已驳回</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="create_time"
              label="提交时间"
            ></el-table-column>
            <el-table-column prop="user_name" label="医生头像">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.head_img"
                  style="border: solid 1px #d3d3d3; width: 42px; height: 42px"
                >
                  <img
                    :src="scope.row.head_img"
                    alt
                    style="width: 40px; height: 40px"
                  />
                </div>
                <div class="headimg" v-else></div>
              </template>
            </el-table-column>
            <el-table-column prop="doctor_name" label="医生姓名">
              <template slot-scope="scope">
                <div>
                  <span
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor: pointer"
                    >{{ scope.row.doctor_name }}</span
                  >
                  <span v-if="scope.row.sex == 1" style="margin-left: 16px"
                    >男</span
                  >
                  <span v-if="scope.row.sex == 2" style="margin-left: 16px"
                    >女</span
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="id_card" label="身份证号"></el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>
            <el-table-column prop="hospital" label="医院名称"></el-table-column>
            <el-table-column label="标记状态">
              <template slot-scope="scope">
                <div>{{ scope.row.remark_status | remarkStatusText }}</div>
                <template v-if="scope.row.remark_status == 1">
                  <div>
                    {{ scope.row.remark_time | dateFormat }}
                  </div>
                  <div>({{ scope.row.remark }})</div>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="注销结果">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">待审核</span>
                <span v-if="scope.row.status == 2">已注销</span>
                <span v-if="scope.row.status == 3">已驳回</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="examine_time"
              label="操作时间"
            ></el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  v-if="!scope.row.remark_status"
                  @click="remarkBtn(scope.row)"
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1735')
                      : false
                  "
                  >标记</el-button
                >

                <template v-if="scope.row.status == 1">
                  <el-button
                    @click="showCancelDia(scope.row.doctor_id)"
                    type="text"
                    size="medium"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('924')
                        : false
                    "
                    >注销</el-button
                  >
                  <el-button
                    @click="refuse(scope.row.log_id)"
                    type="text"
                    size="medium"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('928')
                        : false
                    "
                    >驳回</el-button
                  >
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 注销弹窗 -->
    <el-dialog
      title="提 示"
      :visible.sync="cancelDia"
      width="750px"
      :close-on-click-modal="false"
    >
      <div class="content">
        <div style="color: #ff7200">
          注意：注销账户前，需核实医生问诊、处方、账户等情况。
        </div>
        <div>
          <div class="green">必须处理（以下数据须全部清零后，才可以注销）</div>
          <div class="box">
            <div class="item">
              <div class="title">● 问诊记录</div>
              <div style="padding-left: 12px">
                <span>待确认</span>
                <span style="margin: 0 30px 0 10px"
                  >{{ statistics_info.to_be_confirmed_consult_count }}条</span
                >
                <span>咨询中</span>
                <span style="margin-left: 10px"
                  >{{ statistics_info.consulting_consult_count }}条</span
                >
              </div>
            </div>
            <div class="item">
              <div class="title">● 预约问诊记录</div>
              <div style="padding-left: 12px">
                <span>待确认</span>
                <span style="margin-left: 10px"
                  >{{ statistics_info.to_be_confirmed_register_count }}条</span
                >
              </div>
            </div>
            <div class="item">
              <div class="title">● 分享开方处方</div>
              <div style="padding-left: 12px">
                <span>允许购买</span>
                <span style="margin-left: 10px"
                  >{{
                    statistics_info.allow_purchase_agreement_prescription_count
                  }}个</span
                >
              </div>
            </div>
            <div class="item">
              <div class="title">● 处方记录</div>
              <div style="padding-left: 12px">
                <span>待取药</span>
                <span style="margin: 0 30px 0 10px"
                  >{{
                    statistics_info.medicine_to_be_taken_prescription_count
                  }}条</span
                >
                <span>待审方</span>
                <span style="margin: 0 30px 0 10px"
                  >{{
                    statistics_info.pending_party_prescription_count
                  }}条</span
                >
                <span>已通过</span>
                <span style="margin-left: 10px"
                  >{{ statistics_info.passed_prescription_count }}条</span
                >
              </div>
            </div>
          </div>
          <div class="green">非必须处理（参考）</div>
          <div class="box">
            <div class="item">
              <div class="title">● 诊后服务</div>
              <div style="padding-left: 12px">
                <span>待诊后服务(处方)</span>
                <span style="margin-left: 10px"
                  >{{ statistics_info.after_treatment_service_count }}条</span
                >
              </div>
            </div>
          </div>
          <div class="green">资金账户</div>
          <div class="box">
            <div class="pricebox">
              <div class="priceitem">
                <div class="num">
                  {{ account_info.sa_money }}
                </div>
                <div class="gray">税前总收入</div>
              </div>
              <div class="priceitem">
                <div class="num">
                  {{ account_info.taxation_money }}
                </div>
                <div class="gray">扣缴税额</div>
              </div>
              <div class="priceitem">
                <div class="num">
                  {{ account_info.pay_money }}
                </div>
                <div class="gray">税后总收入</div>
              </div>
            </div>
            <div class="pricebox">
              <div class="priceitem">
                <div class="num red">
                  {{ account_info.wait_money }}
                </div>
                <div class="gray">待结算金额（未入账）</div>
              </div>
              <div class="priceitem">
                <div class="num">
                  {{ account_info.bk_price }}
                </div>
                <div class="gray">平台补扣/补贴</div>
              </div>
              <div class="priceitem">
                <div class="num red">
                  {{ account_info.t_price }}
                </div>
                <div class="gray">账户余额</div>
              </div>
              <div class="priceitem">
                <div class="num">
                  {{ account_info.settle_money }}
                </div>
                <div class="gray">可提现余额</div>
              </div>
              <div class="priceitem">
                <div class="num">
                  {{ account_info.no_settle_money }}
                </div>
                <div class="gray" style="width: 72px">不可提现余额</div>
              </div>
              <div class="priceitem">
                <div class="num">
                  {{ account_info.y_pay_money }}
                </div>
                <div class="gray">总提现</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align: center; padding-bottom: 20px">
        <span slot="footer" class="dialog-footer">
          <el-button
            plain
            @click="cancelDia = false"
            style="width: 92px"
            size="medium"
            >取消操作
          </el-button>
          <el-button
            type="primary"
            @click="cancelDoctor"
            style="width: 92px"
            size="medium"
            >确认注销</el-button
          >
        </span>
      </div>
    </el-dialog>
    <!-- 标记弹框 -->
    <el-dialog
      title="标记"
      :visible.sync="remarkVisible"
      width="660px"
      center
      custom-class="doctor-cancellist-remark"
    >
      <el-form
        :model="remarkForm"
        ref="remarkFormRef"
        style="padding: 20px"
        label-width="78px"
      >
        <el-form-item
          label="标记说明"
          prop="remark"
          :rules="[{ required: true, message: '请输入内容', trigger: 'blur' }]"
        >
          <el-input
            v-model="remarkForm.remark"
            type="textarea"
            :rows="7"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="remarkVisible = false">取 消</el-button>
        <el-button type="primary" @click="remarkConfirm('remarkFormRef')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import DocMsg from "../../../components/common/DocMsg.vue";
import doctor from "../../../api/doctor";
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      doctor_name: "",
      phone: "",
      id_card: "",
      status: 0,
      date: [],
      cancelDia: false,
      account_info: {},
      statistics_info: {},
      doctor_id: "",
      doc_msg: false,
      doctorId: "",
      remark_status: "",
      remark_time: [],
      options: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "待标记",
          value: 0,
        },
        {
          label: "已标记",
          value: 1,
        },
      ],
      remarkVisible: false,
      remarkForm: {
        remark: "",
      },
    };
  },
  components: {
    DocMsg,
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },
    remarkStatusText(val) {
      switch (val) {
        case 0:
          return "待标记";

        case 1:
          return "已标记";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      this.date = [start, end];
      this.getList();
    },
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        phone: this.phone,
        id_card: this.id_card,
        status: this.status,
        remark_status: this.remark_status,
      };
      if (this.date && this.date.length > 0) {
        data.date_time_start = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.date_time_end = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      if (this.remark_time && this.remark_time.length) {
        data.remark_time_start = dayjs(this.remark_time[0]).format(
          "YYYY-MM-DD"
        );
        data.remark_time_end = dayjs(this.remark_time[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/doctor/getDoctorCancelLog", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format("YYYY-MM-DD HH:mm");
              item.examine_time = item.examine_time
                ? dayjs.unix(item.examine_time).format("YYYY-MM-DD HH:mm")
                : "";
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //注销医生弹窗
    showCancelDia(doctor_id) {
      this.doctor_id = doctor_id;
      this.axios
        .post("platform/doctor/getDoctorCurrentAccountNumber", {
          doctor_id,
        })
        .then((res) => {
          if (!res.data.account_info) {
            this.$confirm("该医生账号未认证,确定注销吗?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            })
              .then(() => {
                this.axios
                  .post("platform/doctor/cancelDoctorAccount", { doctor_id })
                  .then((res) => {
                    this.$message.success("该账号已注销");
                    this.getList();
                  });
              })
              .catch(() => {});
          } else {
            this.account_info = res.data.account_info;
            this.statistics_info = res.data.statistics_info;
            this.cancelDia = true;
          }
        });
    },
    //注销医生
    cancelDoctor() {
      if (
        this.statistics_info.to_be_confirmed_consult_count ||
        this.statistics_info.consulting_consult_count ||
        this.statistics_info.to_be_confirmed_register_count ||
        this.statistics_info.allow_purchase_agreement_prescription_count ||
        this.statistics_info.medicine_to_be_taken_prescription_count ||
        this.statistics_info.pending_party_prescription_count ||
        this.statistics_info.passed_prescription_count
      ) {
        this.$message.error("必须处理内容不为0，不可以注销。");
        return false;
      }
      let doctor_id = this.doctor_id;
      this.axios
        .post("platform/doctor/cancelDoctorAccount", { doctor_id })
        .then((res) => {
          this.$message.success("该医生账号已注销");
          this.getList();
          this.cancelDia = false;
        });
    },
    //驳回申请
    refuse(log_id) {
      this.$confirm("确定驳回申请?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.axios
            .post("platform/doctor/rejectDoctorCancel", { log_id })
            .then((res) => {
              this.$message.success("申请已驳回,医生可重新再提交注销申请");
              this.getList();
            });
        })
        .catch(() => {});
    },
    // 标记
    remarkBtn(row) {
      this.remarkForm.log_id = row.log_id;
      this.remarkForm.remark = "";
      this.$refs["remarkFormRef"]
        ? this.$refs["remarkFormRef"].clearValidate()
        : "";
      this.remarkVisible = true;
    },
    // 标记确认
    remarkConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.remarkForm);
          doctor.remarkDoctorCancel(params).then((res) => {
            let { code } = res;
            if (code === 0) {
              this.$message.success("保存成功");
              this.remarkVisible = false;
              this.getList();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.searchbox {
  display: flex;
  margin-bottom: 20px;
  flex-wrap: wrap;
  align-items: center;
  .el-input {
    margin-bottom: 10px !important;
  }
}

.content {
  padding: 20px;
  text-align: left;

  .box {
    background: #f5f5f5;
    margin-top: 8px;
    padding: 10px;
  }

  .green {
    color: #669961;
    font-weight: 700;
    margin-top: 20px;
  }

  .title {
    font-weight: 700;
    margin-bottom: 6px;
  }

  .item {
    margin-bottom: 14px;
  }

  .pricebox {
    display: flex;
    align-items: center;
    padding: 15px 0;
    box-sizing: border-box;

    .priceitem {
      text-align: center;
      padding: 0 20px;
      border-right: solid 1px #d6d6d6;
    }

    .priceitem:before {
      content: "";
    }

    .gray {
      font-size: 12px;
      color: #747981;
      display: inline-block;
    }

    .num {
      font-size: 18px;
      font-weight: 600;
    }

    .red {
      color: #ff0000;
    }
  }
}

.headimg {
  width: 40px;
  height: 40px;
  background: #d8d8d8;
}
</style>
<style lang="scss">
.doctor-cancellist-remark {
  .el-form {
    padding-bottom: 0 !important;
  }
  .el-form-item__content {
    height: 160px;
  }
}
</style>
